/**
 * Product Detail Page - Laoli Theme
 * Main PDP functionality coordinator
 * This file now coordinates other specialized modules
 */

function initPdp() {
  const pdpWrapper = document.querySelector('.laoli-pdp');

  if (!pdpWrapper) {
    return;
  }

  // Initialize all PDP modules
  if (typeof initPdpGallery === 'function') {
    initPdpGallery();
  }
  
  if (typeof initPdpTabs === 'function') {
    initPdpTabs();
  }
  
  if (typeof initPdpNavigation === 'function') {
    initPdpNavigation();
  }
  
  // initPdpSelect is handled by section-main-product.js to avoid double initialization
  
  if (typeof initPdpMobileSelect === 'function') {
    initPdpMobileSelect();
  } else {
    
  }
  
  if (typeof initPdpCart === 'function') {
    initPdpCart();
  } else {
    
  }
  
  if (typeof initPdpMobileCarousel === 'function') {
    initPdpMobileCarousel();
  }
  
  if (typeof initPdpStatus === 'function') {
    initPdpStatus();
  }
}

// Export for use in other scripts
if (typeof module !== 'undefined' && module.exports) {
  module.exports = { initPdp };
}
